import { gatewayRequest } from '@/api/request'
import { axios } from '@/utils/request'

export function gateway(action, data) {
  return axios(gatewayRequest(action, data))
}
